<template>
  <v-row v-if="showBanner">
    <v-card :id="currentBanner.id" align="stretch" width="100%" class="pt-6 pl-6">
      <v-btn
        v-if="skipableBanner"
        class="close-banner-btn"
        icon
        large
        @click="skipBanner"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>

      <v-row
        class="px-0 py-0"
        align="stretch"
      >
        <v-col cols="12" md="6" class="pl-0">
          <v-card-title class="text-dashboard-h1 pt-0">
            {{ currentBanner.title }}
          </v-card-title>
          <v-card-text class="mt-3">
            {{ currentBanner.explainer }}
          </v-card-text>

          <v-btn
            v-if="currentBanner.id === 'tut_finished_card'"
            color="primary"
            class="my-6 mx-4 mt-3"
            @click="tutorialFinishedClick()"
          >
            {{ currentBanner.btnText }}
          </v-btn>
          <v-btn
            v-else
            id="tut_okay_btn"
            color="primary"
            class="my-6 mx-4 mt-3"
            @click="$router.push(currentBanner.btnPath)"
          >
            {{ currentBanner.btnText }}
          </v-btn>
        </v-col>
        <v-col
          align-self="end" md="6" sm="12" class="d-flex flex-row justify-end"
        >
          <v-img max-height="350" :src="currentBanner.imagePath" :alt="currentBanner.explainer"></v-img>
        </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import seal from '@/services/api/seal'
import rsspUtil from '../../services/api/rsspUtil'
import signatureProfiles from '../../services/api/signatureProfiles'
import users from '../../services/api/users'

export default {
  data() {
    return {
      currentBanner: {
        title: '',
        explainer: '',
        btnPath: '',
        btnText: this.$t('dashboard.okUnderstand'),
        imagePath: '',
        id: 'tut_empty_banner'
      },

      showOkBlock: false,
      showSignatureProfileBlock: false,
      tutorialFinished: false,
      showNotActivatedCredentialsBlock: false,
      showDevicesBlock: false,
      showVerificationMandatoryBlock: false,
      showBanner: false,
      showCredentialsBlock: false,
      skipableBanner: false,
      banners: {
        verificationMandatory: {
          title: this.$t('dashboard.banners.verificationMandatory.title'),
          explainer: this.$t('dashboard.banners.verificationMandatory.explainer'),
          btnPath: '/user/profile',
          imagePath: require('@/assets/banners/kycVerificationNeededBanner.png'),
          id: 'no_verification_warning_card'
        },
        noCrededential: {
          title: this.$t('dashboard.banners.noCred.title'),
          explainer: this.$t('dashboard.banners.noCred.explainer'),
          btnPath: '/credentials/add',
          imagePath: require('@/assets/banners/noCredential.png'),
          id: 'no_credential_warning_card'
        },

        noSignatureProfile: {
          title: this.$t('dashboard.banners.noSignatureProfile.title'),
          explainer: this.$t('dashboard.banners.noSignatureProfile.explainer'),
          btnPath: '/signatureProfiles/add',
          imagePath: require('@/assets/banners/signatureProfileBanner.png'),
          id: 'no_signatureprofile_warning_card'
        },
        noDevice: {
          title: this.$t('dashboard.banners.noDevice.title'),
          explainer: this.$t('dashboard.banners.noDevice.explainer'),
          btnPath: '/user/profile',
          imagePath: require('@/assets/banners/noDevice.png'),
          id: 'no_device_warning_card'
        },
        noActiveCredential: {
          title: this.$t('dashboard.banners.noActiveCredential.title'),
          explainer: this.$t('dashboard.banners.noActiveCredential.explainer'),
          btnPath: '/credentials',
          imagePath: require('@/assets/banners/noCredYetMask.jpg'),
          id: 'no_activated_cred_warning_card'
        },
        readyToSign: {
          title: this.$t('dashboard.banners.readyToSign.title'),
          explainer: this.$t('dashboard.banners.readyToSign.explainer'),
          btnPath: '',
          imagePath: require('@/assets/banners/requirementsMeet.png'),
          id: 'tut_finished_card'
        }

      }

    }
  },
  async mounted() {
    await this.loadRequirementsData() // production
    // dev
    // this.showCredentialsBlock = true
    // this.showSignatureProfileBlock = true
    // this.showDevicesBlock = true
    // this.showNotActivatedCredentialsBlock = true
    // this.showOkBlock = true

    await this.showBanners()
  },
  methods: {
    async loadRequirementsData() {
      // Cookie check
      const cookieValue = !!this.$cookies.get('tutorial-finished')
      this.tutorialFinished = (cookieValue !== null ? cookieValue : false) && !this.showCredentialsBlock && !this.showDevicesBlock && !this.showNotActivatedCredentialsBlock

      // user verification needed check
      const currentUser = await users.joinUser()

      this.$store.commit('setCurrentUser', currentUser)
      const verificationMandatory = this.$store.state.currentUser.verificationMandatory
      const verified = this.$store.state.currentUser.verified

      this.showVerificationMandatoryBlock = verificationMandatory && !verified

      // Signature Profiles
      await this.checkSignatureProfiles()
      // credentials + devices
      await rsspUtil.joinUserOnRssp()
      const creds = await rsspUtil.listMyCredentials()
      const credentialListTotalItems = creds.total
      this.showCredentialsBlock = credentialListTotalItems === 0
      const adminOnlyCredentialManagement = this.$store.state.remoteConfig && this.$store.state.remoteConfig.adminOnlyCredentialManagement
      if (adminOnlyCredentialManagement) {
        this.banners.noCrededential.btnPath = '/credentials'
      }
      const devices = await rsspUtil.listMyDevices()
      const devicesListTotalItems = devices.total
      const credentialImplicitTotalItems = creds.content.filter(x => x.authMode === 'IMPLICIT').length

      this.showDevicesBlock = (devicesListTotalItems === 0 && credentialImplicitTotalItems > 0)
      const someCredActivated = creds.content.some(x => x.status === 'ACTIVATED')
      this.showNotActivatedCredentialsBlock = credentialListTotalItems > 0 && !someCredActivated && !this.showDevicesBlock

      this.showOkBlock = !this.tutorialFinished && !(this.showCredentialsBlock && this.showDevicesBlock && this.showNotActivatedCredentialsBlock && this.showSignatureProfileBlock)
    },
    async checkSignatureProfiles() {
      const pageRequest = {
        'page-size': 0
      }
      const page = await signatureProfiles.listMySignatureProfiles(this.search, pageRequest)

      if (page.total === 0) {
        this.showSignatureProfileBlock = true
      }
    },
    tutorialFinishedClick() {
      this.$cookies.set('tutorial-finished', true, 60 * 60 * 24 * 365) // cookie expirity date set to 365 day from now
      this.showBanner = false
      this.tutorialFinished = true
    },

    async showBanners() {
      if (this.showVerificationMandatoryBlock) {
        this.setBannerContent(this.banners.verificationMandatory)
        return
      }

      const sealStatus = await seal.getSealStatus()
      if (sealStatus.enabled && sealStatus.activated) {
        if (this.showSignatureProfileBlock) {
          this.setBannerContent(this.banners.noSignatureProfile)
          return
        }
        if (this.showDevicesBlock) {
          this.setBannerContent(this.banners.noDevice)
          return
        }
        if (this.showNotActivatedCredentialsBlock) {
          this.setBannerContent(this.banners.noActiveCredential)
          return
        }
        if (this.showOkBlock) {
          this.setBannerContent(this.banners.readyToSign)
        }
      } else {
        if (this.showCredentialsBlock) {
          this.setBannerContent(this.banners.noCrededential)
          return
        }
        if (this.showDevicesBlock) {
          this.setBannerContent(this.banners.noDevice)
          return
        }
        if (this.showNotActivatedCredentialsBlock) {
          this.setBannerContent(this.banners.noActiveCredential)
          return
        }

        if (this.showSignatureProfileBlock && !this.$cookies.get('skip-signatureprofile-banner')) {
          this.skipableBanner = true
          this.setBannerContent(this.banners.noSignatureProfile)
          return
        }
        if (this.showOkBlock) {
          this.setBannerContent(this.banners.readyToSign)
        }
      }
    },
    setBannerContent(banner) {
      this.currentBanner.title = banner.title
      this.currentBanner.explainer = banner.explainer
      this.currentBanner.btnPath = banner.btnPath
      this.currentBanner.imagePath = banner.imagePath
      this.currentBanner.id = banner.id
      this.showBanner = true
    },
    skipBanner() {
      this.$cookies.set('skip-signatureprofile-banner', true, 60 * 60 * 24 * 365) // cookie expirity date set to 365 day from now
      this.showBanner = false
      this.skipableBanner = false
    }
  }

}

</script>
<style scoped>
.close-banner-btn{
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 100;
}
</style>
